module.exports = __webpack_public_path__ + "static/logo_png_Logos for dark backgrounds_Full_logo-horizontal-white-346c6f1dcbc286729ae42df1004b8c38.png";